module.exports = __webpack_public_path__ + "assets/img/structure-45e852c5.png";